export default __webpack_public_path__ + "static/media/2022 (3).be110349.jpg";